import { escapeRegExp } from 'lodash';
import { distance } from 'fastest-levenshtein';

// Define your field priorities and their corresponding score multipliers
const FIELD_WEIGHTS = {
  ProdCd: 2.0,
  sProd: 1.5,
  ixProd: 1.5,
  ixSub: 2.0,
  sub_title: 1.5
  // Any field not listed here defaults to a weight of 1.0 (prices, IDs, etc.)
};

const filterListByQueryAndSort = (query = '', list = [], props = []) => {
  if (!query || !list.length) return list;
  const target = query.toLowerCase();
  const searchRegEx = new RegExp(escapeRegExp(query), 'i');

  return list
    .filter(item =>
      props.length === 0
        ? Object.keys(item || {}).some(field =>
            searchRegEx.test((item?.[field] || '').toString())
          )
        : props.some(prop => searchRegEx.test((item?.[prop] || '').toString()))
    )
    .map(item => {
      const keysToSearch = props.length === 0 ? Object.keys(item || {}) : props;
      let maxItemScore = 0;

      keysToSearch.forEach(field => {
        const value = (item?.[field] || '').toString();
        if (!value) return;

        const itemLower = value.toLowerCase();
        let score = 0;

        // 1. Check baseline relevance first
        const hasSubstring =
          itemLower.includes(target) || target.includes(itemLower);

        if (hasSubstring) {
          // Give it the containment boost
          score += 500;

          // Exact match jackpot
          if (itemLower === target) {
            score += 1000;
          }

          // Calculate Levenshtein ONLY for fields that actually have a match
          const d = distance(itemLower, target);
          const maxLen = Math.max(itemLower.length, target.length);
          const similarity = maxLen === 0 ? 1 : 1 - d / maxLen;
          score += similarity * 100;

          const weight = FIELD_WEIGHTS[field] || 1.0;
          score *= weight;
        } else {
          // If the field doesn't match the query string, its score is strictly zero
          score = 0;
        }

        // Track the absolute best score found across the object
        if (score > maxItemScore) {
          maxItemScore = score;
        }
      });

      return { item, score: maxItemScore };
    })
    .sort((a, b) => b.score - a.score)
    .map(wrapped => wrapped.item);
};

export default filterListByQueryAndSort;
